<template>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-table
        ref="grid"
        title="폭기조 운전상태(생물화학적 처리시설의 경우)"
        tableId="grid"
        :columns="grid.columns"
        :gridHeight="grid.height"
        :data="grid.data"
        :usePaging="false"
        :hideBottom="false"
        :columnSetting="false"
        :filtering="false"
        :isExcelDown="false"
        :editable="editable"
        :gridHeightAuto="param.isFullScreen"
      >
        <!-- 버튼 영역 -->
        <template slot="table-button">
          <q-btn-group outline >
            <c-btn label="저장" icon="save" v-if="!param.isFullScreen && editable" @btnClicked="saveData"/>
          </q-btn-group>
        </template>
      </c-table>
    </div>
  </div>
</template>
<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'daily-report-08',
  props: {
    param: {
      type: Object,
      default: () => ({
        plantCd: null,
        envWaterDailyResultId: '',
        isFullScreen: false,
        dailyResultDt: '',
        approvalStatusCd: null,
        approvalTarget: false,
      }),
    },
  },
  data() {
    return {
      grid: {
        columns: [
          {
            name: 'envWaterMstAerationtankName',
            field: 'envWaterMstAerationtankName',
            label: '폭기조명',
            align: 'center',
            sortable: false,
          },
          {
            name: 'oprState01',
            field: 'oprState01',
            label: 'pH',
            align: 'center',
            type: 'text',
            style: 'width:10%',
            sortable: false,
          },
          {
            name: 'oprState02',
            field: 'oprState02',
            label: '수온',
            align: 'center',
            type: 'text',
            style: 'width:10%',
            sortable: false,
          },
          {
            name: 'oprState03',
            field: 'oprState03',
            label: 'DO',
            align: 'center',
            type: 'text',
            style: 'width:10%',
            sortable: false,
          },
          {
            name: 'oprState04',
            field: 'oprState04',
            label: 'SV30',
            align: 'center',
            type: 'text',
            style: 'width:10%',
            sortable: false,
          },
          {
            name: 'oprState05',
            field: 'oprState05',
            label: 'MLSS',
            align: 'center',
            type: 'text',
            style: 'width:10%',
            sortable: false,
          },
          {
            name: 'oprState06',
            field: 'oprState06',
            label: 'SVI',
            align: 'center',
            type: 'text',
            style: 'width:10%',
            sortable: false,
          },
          {
            name: 'aerationTime',
            field: 'aerationTime',
            label: '폭기시간',
            align: 'center',
            style: 'width:10%',
            type: 'datetime',
            minuteStep: 10,
            sortable: false,
          },
          {
            name: 'organismState',
            field: 'organismState',
            label: '주미생물상태',
            align: 'center',
            type: 'text',
            style: 'width:10%',
            sortable: false,
          },
        ],
        height: '600px',
        data: [],
      },
      listUrl: '',
      saveUrl: '',
    };
  },
  watch: {
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  computed: {
    editable() {
      if (this.param.approvalTarget) {
        return true;
      } else if (this.param.approvalStatusCd !== null) {
        return false;
      } else {
        return this.$route.meta.editable
      }
    },
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.listUrl = selectConfig.env.water.daily.aerationtank.list.url;
      this.saveUrl = transactionConfig.env.water.daily.aerationtank.save.url;
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = {envWaterDailyResultId: this.param.envWaterDailyResultId, plantCd: this.param.plantCd};
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    saveData() {
      let saveData = this.grid.data.filter( x => {
        return x.editFlag == 'U' || x.editFlag == 'C'
      });
      this.$_.forEach(saveData, item => {
        item.regUserId = this.$store.getters.user.userId;
        item.chgUserId = this.$store.getters.user.userId;
      });
      if(saveData.length > 0) {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '저장하시겠습니까?', // 저장하시겠습니까?
          type: 'info',
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.saveUrl;
            this.$http.type = 'POST';
            this.$http.param = saveData;
            this.$http.request(() => {
              this.getList();
              window.getApp.$emit('ALERT', {
                title: '안내 ', /* 안내 */
                message: '저장되었습니다.', /* 저장되었습니다. */
                type: 'success', // success / info / warning / error
              });
            });
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      } else {
        window.getApp.$emit('ALERT', {
          title: '안내 ', /* 안내 */
          message: '변경된 데이터가 없습니다.', // 변경된 데이터가 없습니다., /* 변경된 데이터가 없습니다. */
          type: 'info', // success / info / warning / error
        });
      }
    },
  }
};
</script>
